import { render, staticRenderFns } from "./PrescriptionTable.vue?vue&type=template&id=ec10e6fc&"
import script from "./PrescriptionTable.vue?vue&type=script&lang=ts&"
export * from "./PrescriptionTable.vue?vue&type=script&lang=ts&"
import style0 from "./PrescriptionTable.vue?vue&type=style&index=0&id=ec10e6fc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports